import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWireComponent } from './simple-icons-wire.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWireComponent ],
    exports:      [ SimpleIconsWireComponent ],
    bootstrap:    []
})
export class SimpleIconsWireModule {}
